import React, { useMemo } from 'react';
import {
  buildClinicalFieldGroups,
  getClinicalSourceItem,
} from '../../utils/registrationTableColumns';
import './LesionClinicalPanel.css';

function LesionClinicalPanel({
  registrationData,
  selectedRegistrationIndex,
  folderMeta,
}) {
  const selectedItem = useMemo(
    () => getClinicalSourceItem(registrationData, selectedRegistrationIndex),
    [registrationData, selectedRegistrationIndex]
  );

  const fieldGroups = useMemo(
    () => buildClinicalFieldGroups(selectedItem, folderMeta),
    [selectedItem, folderMeta]
  );

  const hasSelection = selectedRegistrationIndex != null;

  return (
    <aside className="lesion-clinical-panel">
      <header className="lesion-clinical-panel__header">
        <h4>Clinical features</h4>
        <p className="lesion-clinical-panel__subtitle">
          {hasSelection
            ? 'Lesion context for the selected image'
            : 'Lesion context for this case'}
        </p>
      </header>

      {fieldGroups.length === 0 ? (
        <p className="lesion-clinical-panel__empty">
          No clinical metadata available for this case.
        </p>
      ) : (
        <div className="lesion-clinical-panel__body">
          {fieldGroups.map((group) => (
            <section key={group.title} className="lesion-clinical-panel__section">
              <h5>{group.title}</h5>
              <dl className="lesion-clinical-panel__list">
                {group.fields.map((field) => (
                  <div key={`${group.title}-${field.label}`} className="lesion-clinical-panel__row">
                    <dt>{field.label}</dt>
                    <dd>{field.value}</dd>
                  </div>
                ))}
              </dl>
            </section>
          ))}
        </div>
      )}
    </aside>
  );
}

export default LesionClinicalPanel;
